import { Group, Stack, Space, Checkbox, Progress } from "@mantine/core";
import { Text } from "@/components/ui/Text";

import { IconArrowDown, IconUser } from "@tabler/icons-react";
import { useStyles } from "@/styles/useStyles";

export const TotalRequiredCountCheckbox = ({
  isSmall = false,
  isCompleted = false,
  isExportView = false,
  totalAdvizersWatched,
  totalAdvizersRequired,
}: {
  isSmall?: boolean;
  isCompleted?: boolean;
  isExportView?: boolean;
  totalAdvizersWatched: number;
  totalAdvizersRequired: number;
}) => {
  return (
    <Stack gap={4} w="100%" flex={1}>
      <Group
        flex={1}
        gap={0}
        // opacity={isCompleted ? 0.7 : 1}
        align="center"
        w="100%"
      >
        <Checkbox
          color="primary"
          size={isSmall ? "xs" : "md"}
          readOnly
          checked={isCompleted}
        />
        <Space w="md" />
        <Stack flex={1} gap={0}>
          <Group
            gap={0}
            pl={isSmall ? 4 : 8}
            flex={1}
            justify="flex-start"
            w="100%"
          >
            <Text titleStyle={isSmall ? "h6" : "h5"} fw={500}>
              Watch videos from at least{" "}
              <span style={{ fontWeight: 700 }}>
                {totalAdvizersRequired} Advizers
              </span>{" "}
            </Text>
            {isSmall ? null : (
              <>
                <Space w="md" />
                <a href="#my-advizers" style={{ fontSize: 13 }}>
                  <Group gap={4}>
                    View My Advizers <IconArrowDown size={16} />
                  </Group>
                </a>
              </>
            )}
          </Group>
          <Space h={4} />
        </Stack>
      </Group>

      <Group
        flex={1}
        justify="space-between"
        wrap="nowrap"
        pl={isSmall ? "xl" : 48}
        pt={isExportView ? 8 : undefined}
        w="100%"
      >
        <RequiredCountProgress
          totalAdvizersWatched={totalAdvizersWatched}
          totalAdvizersRequired={totalAdvizersRequired}
          isSmall={isSmall}
        />
      </Group>
    </Stack>
  );
};

function RequiredCountProgress({
  totalAdvizersWatched,
  totalAdvizersRequired,
  isSmall,
}: {
  totalAdvizersWatched: number;
  totalAdvizersRequired: number;
  isSmall: boolean;
}) {
  const { theme } = useStyles();
  return (
    <Group
      w="100%"
      justify="center"
      align="center"
      flex={1}
      // pl={0}
      // pr="md"
      // pt={4}
      gap={4}
    >
      <IconUser
        size={isSmall ? 12 : 16}
        style={{ color: theme.colors.text[7] }}
      />
      <Text lh={1.2} c="text.7" size={isSmall ? "xs" : "sm"}>
        {totalAdvizersWatched}
      </Text>
      <Space w={8} />
      <Progress
        value={(totalAdvizersWatched / totalAdvizersRequired) * 100}
        color="primary.7"
        flex={1}
        size={isSmall ? "sm" : "md"}
        transitionDuration={1000}
      />
      <Space w={8} />

      <Text lh={1.2} size={isSmall ? "xs" : "sm"}>
        {totalAdvizersRequired} Advizers
      </Text>
    </Group>
  );
}
